<template>
  <section>
    <PageTitle>
      <span v-html="$store.state.app.pageName" />
    </PageTitle>
    <PageContent>
      <Container :mobile-fluid="true">
        <div class="tab">
          <div class="tab-list">
            <div
              class="tab-list-item"
              :class="{ 'is-active': tab === 1 }"
              @click="tab = 1"
            >
              今後の予定
            </div>
            <div
              class="tab-list-item"
              :class="{ 'is-active': tab === 2 }"
              @click="tab = 2"
            >
              過去の予定
            </div>
          </div>
          <div class="tab-item-wrapper">
            <div class="tab-item" :class="{ 'is-active': tab === 1 }">
              <ul class="list-group">
                <li
                  class="list-group-item"
                  v-for="(event, i) in futureEvents"
                  :key="i"
                >
                  <EventRow :event="event" />
                </li>
              </ul>
            </div>
            <div class="tab-item" :class="{ 'is-active': tab === 2 }">
              <ul class="list-group">
                <li
                  class="list-group-item"
                  v-for="(event, i) in pastEvents"
                  :key="i"
                >
                  <EventRow :event="event" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </Container>
    </PageContent>
  </section>
</template>

<script>
import moment from 'moment'
import api from '@/api/meeting'
import { renderError } from '@/utils/error'
import EventRow from '@/components/EventRow'

export default {
  components: {
    EventRow,
  },

  metaInfo() {
    return {
      title: this.$store.state.app.pageName,
      bodyAttrs: { class: 'meeting' }
    }
  },

  data() {
    return {
      tab: 1,
      events: [],
    }
  },

  computed: {
    // 過去のイベント
    pastEvents() {
      const today = moment().startOf('day')
      return this.events.filter(e => moment(e.date).isBefore(today))
    },
    // 今後のイベント
    futureEvents() {
      const today = moment().startOf('day')
      return this.events.filter(e => moment(e.date).isSameOrAfter(today))
    }
  },

  methods: {
    async fetchEvents() {
      const businessId = this.$store.getters['auth/businessId']
      try {
        this.events = await api.get(businessId)
      } catch (err) {
        renderError(err)
      }
    }
  },

  created() {
    this.$withLoading(this.fetchEvents)
  }
}
</script>
